const en = {
    'security.login.error': 'Incorrect username or password',
    'security.token.error': 'Incorrect token',
    'security.login.email': 'Email',
    'security.login.password': 'Password',
    'security.login.login': 'Login',
    'security.login.loginwith': 'Login with',
    'security.login.loginOld': 'Login with old intranet',
    'security.login.forgotPassword': 'Forgot password?',
    'security.forgotPassword.title': 'Reset password',
    'security.forgotPassword.description': 'Enter your corporate email address and we will send you a link to reset your password.',
    'security.forgotPassword.send': 'Send link',
    'security.forgotPassword.cancel': 'Cancel',
    'security.forgotPassword.success': 'If the email is registered in our system, you will receive a link to reset your password. Please check your spam folder.',
    'security.forgotPassword.error': 'An error occurred while requesting password reset. Please try again.',
    'security.resetPassword.title': 'Reset password',
    'security.resetPassword.subtitle': 'Enter your new intranet password.',
    'security.resetPassword.newPassword': 'New password',
    'security.resetPassword.confirmPassword': 'Confirm new password',
    'security.resetPassword.submit': 'Update password',
    'security.resetPassword.success': 'Your password has been successfully reset. You can now log in with your new password.',
    'security.resetPassword.error': 'Failed to reset password. The link may have expired or is invalid.',
    'security.resetPassword.mismatch': 'Passwords do not match.',
    'security.resetPassword.tooShort': 'Password must be at least 8 characters long.',
    'security.resetPassword.invalidToken': 'The recovery link is invalid or has expired.',
    'security.resetPassword.backToLogin': 'Back to login',
    'security.resetPassword.requestNewLink': 'Request a new link',
};

export default en;